"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../../../shared");
var DatePickerDay_meta_1 = require("./DatePickerDay.meta");
var DatePickerUtils_1 = require("../../DatePickerUtils");
var ButtonDay_1 = __importDefault(require("../../styledComponents/DatePickerDay/ButtonDay"));
var DayClassNameEnum_1 = require("./models/DayClassNameEnum");
var DatePickerDay = /** @class */ (function (_super) {
    __extends(DatePickerDay, _super);
    function DatePickerDay(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = DatePickerDay_meta_1.DATE_PICKER_DAY_CATEGORY_KEY;
        _this.componentKey = DatePickerDay_meta_1.DATE_PICKER_DAY_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(DatePickerDay.prototype, "parentComponentKey", {
        get: function () {
            return DatePickerDay_meta_1.DATE_PICKER_DAY_PARENT_COMPONENT_KEY;
        },
        enumerable: true,
        configurable: true
    });
    DatePickerDay.prototype.render = function () {
        var _a = this.props, focusedDay = _a.focusedDay, today = _a.today, day = _a.day, onDaySelect = _a.onDaySelect, onKeyboardNavigation = _a.onKeyboardNavigation, focusedDayRef = _a.focusedDayRef, disabled = _a.disabled, inRange = _a.inRange, isSelected = _a.isSelected, dateFormatter = _a.dateFormatter;
        // Is todays day
        var isToday = DatePickerUtils_1.isEqual(day, today);
        // Is a day in the current month
        var isMonth = DatePickerUtils_1.isEqualMonth(day, focusedDay);
        var isFocused = DatePickerUtils_1.isEqual(day, focusedDay);
        // Is not inside min and max date range
        var isOutsideRange = !inRange;
        function handleClick(e) {
            onDaySelect(e, day);
        }
        // Builds up dynamic styling which is targeted by the style selectors 
        var className = [];
        if (isOutsideRange) {
            className.push(DayClassNameEnum_1.DayClassNameEnum.isOutside);
        }
        if (isToday) {
            className.push(DayClassNameEnum_1.DayClassNameEnum.isToday);
        }
        if (isMonth) {
            className.push(DayClassNameEnum_1.DayClassNameEnum.isMonth);
        }
        if (disabled) {
            className.push(DayClassNameEnum_1.DayClassNameEnum.isDisabled);
        }
        return (react_1.default.createElement(ButtonDay_1.default, { className: className.join(' '), tabIndex: isFocused ? 0 : -1, onClick: handleClick, onKeyDown: onKeyboardNavigation, "aria-disabled": disabled ? 'true' : undefined, disabled: isOutsideRange, type: "button", "aria-pressed": isSelected ? 'true' : 'false', "aria-current": isToday ? 'date' : undefined, innerRef: function (el) {
                if (isFocused && el && focusedDayRef) {
                    focusedDayRef(el);
                }
            } },
            react_1.default.createElement("span", { "aria-hidden": "true" }, day.getDate()),
            react_1.default.createElement("span", { className: "vhidden" }, dateFormatter.format(day))));
    };
    DatePickerDay = __decorate([
        mobx_react_1.observer
    ], DatePickerDay);
    return DatePickerDay;
}(shared_1.ComponentBase));
exports.DatePickerDay = DatePickerDay;
exports.default = shared_1.InjectedStyledComponent(DatePickerDay, DatePickerDay_meta_1.DATE_PICKER_DAY_CATEGORY_KEY, DatePickerDay_meta_1.DATE_PICKER_DAY_PARENT_COMPONENT_KEY, [DatePickerDay_meta_1.DATE_PICKER_DAY_COMPONENT_KEY]);
